

//namespace PaperTrail.NewsletterControl {
//    @Serenity.Decorators.registerEditor('PaperTrail.NewsletterControl.PageTemplateEditor')
//    export class PageTemplateEditor extends Serenity.Extensions.GridEditorBase<PageTemplateRow> {
//        protected getColumnsKey() { return PageTemplateColumns.columnsKey; }
//        protected getDialogType() { return PageTemplateEditorDialog; }
//        protected getLocalTextPrefix() { return PageTemplateRow.localTextPrefix; }

namespace PaperTrail.NewsletterControl {


    export interface InviteContributorOptions {
        Inviter: string;
        SubscriptionId: number;
        SubscriptionName: string;
        NewsLetterId: number;
        NewsletterName: string;
    }

    @Serenity.Decorators.registerClass()
    export class InviteContributorDialog extends Serenity.TemplatedDialog<InviteContributorOptions> {

        private inviteesEntry: Serenity.TextAreaEditor;
        private commentsEntry: Serenity.HtmlNoteContentEditor;
        private newsletterId: number;

        constructor(opt: InviteContributorOptions) {
            super(opt); 

            this.inviteesEntry = new Serenity.TextAreaEditor(this.byId('Invitees'), { rows: 5, cols: 30 });
            this.commentsEntry = new Serenity.HtmlNoteContentEditor(this.byId('Comments'), { rows: 5 });

            this.newsletterId = 1;
            this.dialogTitle = "Invite Contributors";
        }

        protected getTemplate() {
            return `<div><p><span>Enter emails to invite. One email per line.</span></p><textarea  id="~_Invitees" style="width: 100%;"></textarea><br/><p><span>Do you have anything you want to say:</span></p><input id="~_Comments"/></div>`;
        }

        protected getDialogButtons() {
            return [
                {
                    text: Q.text("Send Invites"),
                    click: () => {
                        var emails = this.inviteesEntry.value;
                        if (!emails.length) {
                            Q.alert("Please enter at least one email!");
                            return;
                        }

                        var emailsArr = emails.split("\n");
                        var doCancel = false;
                        emailsArr.forEach(e => {
                            if (!this.isEmail(e)) { doCancel = true; Q.alert("This email is invalid: " + e) }
                            
                            return;
                        })
                        if (doCancel) return;
        //public string Inviter { get; set; }
        //public string[] Invitees { get; set; }
        //public int NewsletterID { get; set; }
        //public string NewsletterName { get; set; }
                        //public string Comments { get; set; }
                        if (emailsArr.length == 0) { Q.notifyWarning("Please enter at least one email!"); return; }
                         
                        NewsletterService.InviteContributors({
                            Inviter: this.options.Inviter,
                            Invitees: emailsArr,
                            SubscriptionID: this.options.SubscriptionId,
                            SubscriptionName: this.options.SubscriptionName, 
                            NewsletterID: this.options.NewsLetterId,
                            NewsletterName: this.options.NewsletterName,
                            Comments: this.commentsEntry.get_value()
                        }, response => {
                            if (response.IsSuccess) {
                                this.dialogClose();
                                Q.success("Invitations Sent!", null);
                            }
                            else {

                                Q.alert("Oops: " + response.Message);
                            }
                        });
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
        }

        private isEmail(email) {
            var EmailRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return EmailRegex.test(email);
        }
    }
}